import axios from "axios"

const API_URL = process.env.VUE_APP_API_URL

const checkoutService = {
  async processCheckout(id, status, queryData, isAnulate = false) {
    try {
      const endpoint =
                (status === "approved" ? "approved" : "declined") +
                (isAnulate ? "-anulate" : "")
      const response = await axios.post(
        `${API_URL}/v1/checkout/${endpoint}/${id}`,
        queryData,
      )

      return response.data
    } catch (error) {
      throw new Error(
                error.response?.data?.message ||
                    `Error al procesar el checkout: ${status}`,
      )
    }
  },
}

export default checkoutService
